module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_12-208b839295451ecce9f6987e747907c3.jpg";